// import BannerTitle from "../font_component/banner_title/BannerTitle";

import HomeBanner from "./banner_section/HomeBanner";
import CardSection from "./card_section/CardSection";
import ProductSection from "./productsection/ProductSection";
import SwiperCard from "./swiper_card/SwiperCard";
import AboutSpirulina from "./about_spirulina/AboutSpirulina";
import ShareholderOpportunity from "./../about_us/shareholderopportunity/ShareholderOpportunity";
import SupplementBanner from "./supplement_banner/SupplementBanner";
import SpirulinaLevels from "./../about_us/spirulinalevels/SpirulinaLevels";
import TestimonialSwiper from "./testimonials_section/TestimonialSwiper";

function Home() {
  return (
    <>
      <HomeBanner />
      <CardSection />
      {/* abhishek */}
      <ProductSection />
      <SwiperCard />
      <AboutSpirulina />
      <ShareholderOpportunity />
      <SupplementBanner />
      <SpirulinaLevels />
      <TestimonialSwiper />
    </>
  );
}

export default Home;
